
import { v4 as uuidv4 } from 'uuid';

const BUSINESS_TYPES = [
  'Manufacturing',
  'Agriculture',
  'Technology',
  'Retail',
  'Healthcare',
  'Construction',
  'Education',
  'Transportation'
];

const LOAN_PURPOSES = [
  'Business expansion',
  'Equipment purchase',
  'Working capital',
  'Inventory financing',
  'Debt consolidation',
  'New location opening',
  'Technology upgrade',
  'Staff training'
];

const BUSINESS_STORIES = [
  'Looking to expand our successful local business by opening a new branch to meet growing demand.',
  'Need to purchase modern equipment to increase production efficiency and create more local jobs.',
  'Seeking working capital to take advantage of bulk purchase discounts from suppliers.',
  'Planning to upgrade our technology infrastructure to better serve our customers.',
  'Want to consolidate existing loans to improve cash flow and business stability.',
  'Expanding our agricultural business to include modern farming techniques.',
  'Investing in staff training programs to improve service quality.',
  'Modernizing our manufacturing facility with automated equipment.'
];

const PERSONAL_PURPOSES = [
  'Education',
  'Professional development',
  'Home renovation',
  'Medical expenses',
  'Vehicle purchase',
  'Wedding expenses',
  'Family support',
  'Emergency funds'
];

const PERSONAL_STORIES = [
  'Pursuing advanced education to enhance career prospects and contribute to community development.',
  'Investing in professional certifications to qualify for better job opportunities.',
  'Need to renovate home to accommodate growing family needs.',
  'Seeking funds for essential medical procedures not covered by insurance.',
  'Looking to purchase a reliable vehicle for work commute.',
  'Planning a traditional wedding celebration with family and friends.',
  'Supporting family members through difficult times.',
  'Building an emergency fund for unexpected expenses.'
];

export const generateMockLoans = (count: number) => {
  return Array.from({ length: count }, (_, index) => {
    const isBusinessLoan = Math.random() > 0.4; // 60% chance of business loans
    const amount = isBusinessLoan 
      ? Math.floor(Math.random() * 90000) + 10000 
      : Math.floor(Math.random() * 20000) + 5000;
    
    const fundingProgress = Math.floor(Math.random() * amount * 0.8); // Random progress up to 80%
    const deadline = new Date();
    deadline.setDate(deadline.getDate() + Math.floor(Math.random() * 30) + 15); // 15-45 days deadline

    const interestRate = Math.floor(Math.random() * 10) + 5; // 5-15%
    const termMonths = Math.floor(Math.random() * 24) + 12; // 12-36 months
    const monthlyPayment = (amount * (1 + interestRate/100)) / termMonths;
    
    const businessType = BUSINESS_TYPES[Math.floor(Math.random() * BUSINESS_TYPES.length)];
    const purpose = isBusinessLoan 
      ? LOAN_PURPOSES[Math.floor(Math.random() * LOAN_PURPOSES.length)]
      : PERSONAL_PURPOSES[Math.floor(Math.random() * PERSONAL_PURPOSES.length)];
    const story = isBusinessLoan
      ? BUSINESS_STORIES[Math.floor(Math.random() * BUSINESS_STORIES.length)]
      : PERSONAL_STORIES[Math.floor(Math.random() * PERSONAL_STORIES.length)];

    const hasCollateral = Math.random() > 0.5;
    const collateralValue = hasCollateral ? amount * 1.5 : null;

    // Increase chance of approved loans to 60% (was 30%)
    const statuses = ['pending', 'approved', 'active', 'rejected', 'completed'];
    const statusWeights = [0.15, 0.6, 0.15, 0.05, 0.05]; // 60% chance of 'approved'
    
    const random = Math.random();
    let statusIndex = 0;
    let cumulativeWeight = statusWeights[0];
    
    while (random > cumulativeWeight && statusIndex < statusWeights.length - 1) {
      statusIndex++;
      cumulativeWeight += statusWeights[statusIndex];
    }
    
    const status = statuses[statusIndex];
    
    // For approved loans, add a disbursement date
    const disbursementDate = (status === 'approved' || status === 'active') 
      ? new Date(Date.now() - Math.random() * 14 * 24 * 60 * 60 * 1000).toISOString() 
      : null;
      
    // For active loans, add a next payment date
    const nextPaymentDate = status === 'active'
      ? new Date(Date.now() + Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString()
      : null;

    return {
      id: uuidv4(),
      amount,
      funding_progress: fundingProgress,
      funding_deadline: deadline.toISOString(),
      status,
      created_at: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
      interest_rate: interestRate,
      term_months: termMonths,
      monthly_payment: monthlyPayment,
      category: isBusinessLoan ? 'business' : 'personal',
      purpose,
      story,
      disbursement_date: disbursementDate,
      next_payment_date: nextPaymentDate,
      borrower: {
        profile: isBusinessLoan ? {
          business_name: `${businessType} Enterprise ${index + 1}`,
          business_type: businessType,
          phone_number: '+233' + Math.floor(Math.random() * 1000000000),
          country: 'Ghana',
          first_name: null,
          last_name: null
        } : {
          first_name: ['John', 'Jane', 'Mike', 'Sarah', 'David', 'Emma', 'Daniel', 'Grace'][Math.floor(Math.random() * 8)],
          last_name: ['Doe', 'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller'][Math.floor(Math.random() * 8)],
          phone_number: '+233' + Math.floor(Math.random() * 1000000000),
          country: 'Ghana',
          business_name: null,
          business_type: null
        }
      },
      collateral: hasCollateral ? {
        id: uuidv4(),
        property_id: uuidv4(),
        collateral_value: collateralValue,
        status: 'pending'
      } : null
    };
  });
};
